<template>
  <section class="basic-grid home">
    <div class="search-header">
        <div class="search-header-inner">
        <!-- <div class="info-section">
          <div class="logo has-color-initial">
            <i class="fas fa-recycle"></i>
          </div>
          <div class=" has-color-initial" v-html="info.description"></div>
        </div> -->
        <div class="search-upper has-color-initial">
          <SearchBlock2 @filterChange='search_filter=$event; first_search=true;' @searchFocus='first_search=true; firstTransitionDone=true;' ref="searchComp" :results_count="result_count" :search_prompt='info.search_prompt' :placeholders="info.placeholders"/>
          <div class="common-items" v-if="info.common_items"> 
            <!-- <p><i>Find businesses that accept materials for recycling, donations and disposal.</i></p> -->
            <!-- <h4>Common items:</h4> -->
            <ul>
              <li v-for="item in info.common_items" v-bind:key="item.id">
                <a href="#" :data-id="item.node.id" v-on:click="changeSearch(item.node.name)"><i :class="'fad '+itemIcon(item)"></i>{{ item.node.name }}</a>
              </li>
            </ul>
          </div>
          <div class="text-small note-section collapse-mobile" :class="{ 'collapse-mobile-closed':note_section_mobile_closed }" @click="toggleNotes" v-html="info.description"></div>
           <!-- <p class="text-small" style="margin-bottom: 1rem; margin-top: .75rem;"><b>Note:</b> Lewis County maintains this list as a courtesy to the public, and does not endorse or guarantee the quality of the services offered or provided.</p>
           <p class="text-small">If you see an error in any listings, please contact swu@lewiscountywa.gov.</p> -->
        </div>
      </div>
    </div>

    
    <div class="search">
          <!-- <img class="county-logo" src="@/assets/images/county_logo_white.png"> -->
      <transition name="slide" @after-enter="slideIsOpen=true">
        <div class="box radius search-box has-background-initial" v-show="first_search && firstTransitionDone">
          <Pagination :pageType='"pages.BasicPage"' :limit='9' :fields='["*","-node"]' :filters='search_filter' :order='"title"' :group_by_nodes='true' @resultTotal="result_count=$event;" @moreInfo="moreInfo=$event" :slideIsOpen="slideIsOpen" @transitionDone="canOpen()"/>
        </div>
      </transition>
    </div>
     <!-- <SVGBack /> -->
    <transition name="fade" appear>
        <div class="menu-background" v-on:click="moreInfo.nodes=[]" v-if="moreInfo.nodes.length > 0"></div>
    </transition>
     <Slideout :moreInfo="moreInfo" />
  </section>
</template>

<script>
// @ is an alias to /src
import SearchBlock2 from '@/components/SearchBlock2.vue'
import Pagination from '@/components/Pagination.vue'
import SVGBack from '@/components/SVGAnimation.vue'
import Slideout from '@/components/Slideout.vue'
import axios from 'axios'
export default {
  name: 'home',
  components: {
    SearchBlock2,
    SVGBack,
    Pagination,
    Slideout,
  },
  data(){
    return {
      info: [],
      search_filter: [],
      result_count: 0,
      first_search: false,
      slideIsOpen: false,
      firstTransitionDone: false,
      moreInfo: {
        name: '',
        description: '',
        website: '',
        address: '',
        phone_number: '',
        nodes: []
      },
      isActive: false,
      note_section_mobile_closed: true,
    }
  }, 
  // watch:{
  //   $route (to, from){
  //     this.fetchData().then(data =>{
  //       this.info = data
  //     })
  //   }
  // },
  created (){
    this.fetchData().then(data =>{
      console.log('INFO: ',data.map_search)
      this.info = data
      if (this.info.custom_styles) {
        let styles = document.createElement('style');
        styles.type = 'text/css';
        styles.id = 'temp-styles';
        for (let d in this.info.custom_styles) {
          if (!this.info.custom_styles[d].value.hide) {
            styles.appendChild(document.createTextNode(this.info.custom_styles[d].value.style));
          }
        }
        document.getElementsByTagName("head")[0].appendChild(styles);
      }
    })
  },
  beforeRouteLeave (to, from, next){
    if (this.info.custom_styles) {
      let tempSty = document.getElementById('temp-styles');
      if (tempSty) {
        tempSty.remove();
      }
    }
    next();
  },
  mounted (){
    //  console.log('MOUNTED PAGE')
   
  },
  updated(){
    // console.log('UPDATED PAGE')
    // console.log(this.info)
  },
  methods:{
    canOpen() {
      if (this.first_search) {
        this.firstTransitionDone = true
      }
    },
    fetchData(){
      // console.log('FETCH THE DATA')
       var id = this.$route.meta.id
       return axios.get('/api/v2/pages/'+id).then(response => {
        //  console.log(JSON.stringify(response))
         return response.data
       })
    },
    itemIcon(item) {
      if (item.icon) {
        return 'fa-'+item.icon
      } else if (item.node.icon) {
        return 'fa-'+item.node.icon
      }
      return ''
    },
    // # OLD
    // changeSearch(name, groupBool) {
    //   let option = document.getElementById('option-'+name.replace(' ', '-'));
    //   console.log("This is the option: ", option)
    //   if (groupBool) {
    //     let eve = document.createEvent('MouseEvents');
    //     eve.initEvent('mousedown', true, true);
    //     option.dispatchEvent(eve)
    //   } else {
    //     option.click()
    //   }
    // }
    
    // NEW
    changeSearch(newVal) {
      this.$refs.searchComp.setSearchText(newVal);
    },
    toggleNotes() {
      this.note_section_mobile_closed = !this.note_section_mobile_closed;
    }
  }
}
</script>

<style lang="sass">
  .full-width .tagline.row 
      padding: 2.5rem 4rem

  .home .hero
    line-height: 0

  .tagline
    padding-top: 1.5rem
    padding-bottom: 3.25rem


  .promoted-events
    line-height: 0

    .overlay
      display: flex
      flex-direction: column
      justify-content: flex-end
      align-items: flex-start
      padding: 0rem 0rem 1rem 3rem

      h4, h3 
        margin-bottom: .75rem



    
    // background-image: url('~@/assets/images/band.jpg')
  // .home
  //   line-height: 0

  // h3 
  //   color: $color-primary;

  // .sub-menu
  //   top: 2.5rem;

  // nav
  //   background: #333;
  
</style>

<style scoped>
  .menu-background{
      position: fixed;
      top: 0;
      width: 100%;
      bottom: 0;
      left: 0;
      opacity: 1;
      background: rgba(0,0,0,.65);
      z-index: 2;
      transition: all .35s ease-in-out;
      cursor: pointer;
      z-index: 2;
      display: block;
  }

  .note-section {
    margin-bottom: 1rem;
    margin-top: .75rem;
  }

  /* .home{
    padding-top: 50px;
    overflow: hidden;
    height: 100vh;
    width: 100vw;
  }

  .grid-container {
    display: grid;
    grid-template-columns: 1fr 3fr;
    grid-template-rows: 20% auto 1fr;
    gap: 30px;
    height: 100%;
    width: 100%;
  }
  .item-logo {
    grid-area: 1 / 1 / 2 / 2;
    background-color: goldenrod;
  }
  .item-about {
    grid-area: 2 / 1 / 3 / 2;
    background-color: gray;
  }
  .item-faq {
    grid-area: 3 / 1 / 4 / 2;
    background-color: green;
  }
  .item-search {
    grid-area: 1 / 2 / 3 / 3;
    background-color: honeydew;
  }
  .item-locations {
    grid-area: 3 / 2 / 4 / 2;
    background-color: hotpink;
  }
  [class*="item-"]{
 
  } */
.fade-enter-active, .fade-leave-active{ 
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to{ /* .fade-leave-active below version 2.1.8 */ 
    opacity: 0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-enter-active {
  transition: all .75s ease;
}
.slide-leave-active {
  /* transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0); */
  transition: all .75s ease;
}
.slide-enter, .slide-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(100%);
  /* opacity: 0; */
}

.search{
  overflow: visible;
}

.county-logo{
  display: none;
  margin: 0 auto;
}

@media (min-width: 1025px){
  .search .county-logo{
    /* position: absolute; */
    width: 50%;
    max-width: 500px;
    display: block;
    /* right: 20%;
    top: 4%; */
    /* top:0; */
    opacity: .5;
  }
}

@media (max-width: 1024px) and (min-width: 641px) and (min-height: 769px){
  .search .county-logo{
    /* position: absolute; */
    width: 50%;
    display: block;
    /* top: 0; */
    opacity: .5;
  }
}
</style>